import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Avatar, Typography, Grid, Paper } from "@material-ui/core";
import { Phone, MailOutline } from "@material-ui/icons";
import HelpButtonStyle from "../styles";
import { useTranslation } from "react-i18next";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import DefaultAvatar from "assets/img/default-avatar.png";
import { SUPPORT_CONTACT } from "../queries";

const useStyles = makeStyles(HelpButtonStyle);

function ContactSupport(props) {
  const { open } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const { data } = useQueryWithErrorHandling(SUPPORT_CONTACT, { skip: open === false });
  const supportContact = data && data.getSupportContact;

  return (
    <Paper elevation={20} className={classes.paper}>
      <Grid container className={classes.gridContainer} spacing={2} direction="column">
        <Grid container item spacing={2} direction="row" className={classes.gridItem}>
          <Grid item>
            <Avatar src={(supportContact && supportContact.boSupportPicture) || DefaultAvatar} />
          </Grid>
          <Grid item>
            <Typography align="left">{(supportContact && supportContact.boSupportName) || ""}</Typography>
            <Typography align="left">{t("DLSupport")}</Typography>
          </Grid>
        </Grid>
        <Grid container item spacing={2} direction="row" className={classes.gridItem}>
          <Grid item>
            <Avatar>
              <Phone />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography align="left">{(supportContact && supportContact.boSupportPhone) || ""}</Typography>
          </Grid>
        </Grid>
        <Grid container item spacing={2} direction="row" className={classes.gridItem}>
          <Grid item>
            <Avatar>
              <MailOutline />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography align="left">{(supportContact && supportContact.boSupportEmail) || ""}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

ContactSupport.propTypes = {
  open: PropTypes.bool,
};

export default ContactSupport;
